import { useEffect, useMemo, useState } from "react";
import { IBenefit } from "../../../interfaces/api";

const SingleInfoBenefit = ({
  benefit,
  title,
  subtitle = "",
  searcher,
}: {
  benefit: IBenefit[];
  title: string;
  subtitle?: string;
  searcher?: string;
}) => {
  const [searcherContent, setSearcherContent] = useState("-");
  const allDescriptionLines: string[] = useMemo(() => {
    const arr: string[] = [];
    benefit.forEach((singleBenefit) => {
      if (singleBenefit.pbpBenefitDesc) {
        const lines = singleBenefit.pbpBenefitDesc
          .replace(/\\*\\n/g, "\n")
          .replace(/\\/g, "")
          .split("\n")
          .filter(Boolean);
        arr.push(...lines);
      }
    });
    return arr;
  }, [benefit]);

  useEffect(() => {
    if (searcher) {
      const restorativeServicesObject = allDescriptionLines.find((obj) =>
        obj.includes(searcher)
      );

      if (restorativeServicesObject) {
        const startIndex =
          restorativeServicesObject.indexOf(searcher) + searcher.length + 2;
        const content = restorativeServicesObject.substring(startIndex);
        setSearcherContent(content);
      }
    }
  }, [allDescriptionLines, searcher]);

  return (
    <>
      <div
        className="grid-x hide-for-small-only"
        style={{
          width: "100%",
          padding: "32px 20px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div className="cell small-4">
          <div style={{ fontSize: "18px", fontWeight: 600 }}>{title}</div>
          {!!subtitle && <div>{subtitle}</div>}
        </div>
        {searcher ? (
          <div className=" cell small-8" style={{ paddingLeft: 20 }}>
            {searcherContent.length > 1 ? searcherContent : "-"}
          </div>
        ) : (
          <div className=" cell small-8" style={{ paddingLeft: 20 }}>
            {benefit.length > 0
              ? benefit.map((singleBenefit, index) => (
                  <div style={{ paddingBottom: 10 }} key={index}>
                    {benefit.length > 1 && (
                      <div style={{ fontWeight: 600, padding: "10px 0px" }}>
                        {singleBenefit.pbpBenefitName}
                      </div>
                    )}
                    {singleBenefit.pbpBenefitDesc &&
                      singleBenefit.pbpBenefitDesc
                        .replace(/\\*\\n/g, "\n")
                        .replace(/\\/g, "")
                        .split("\n")
                        .filter(Boolean)
                        .map((line, lineIndex) => (
                          <div key={lineIndex}>{line}</div>
                        ))}
                  </div>
                ))
              : "-"}
          </div>
        )}
      </div>
      <div
        className="grid-x show-for-small-only"
        style={{
          width: "100%",
          padding: "32px 10px",
          borderBottom: "1px solid #D3E1F0",
        }}
      >
        <div
          className="cell small-4"
          style={{ fontSize: "14px", fontWeight: 600, paddingRight: 10 }}
        >
          {title}
        </div>
        {searcher ? (
          <div
            className=" cell small-8"
            style={{ paddingLeft: 20, fontSize: 14 }}
          >
            {searcherContent}
          </div>
        ) : (
          <div className=" cell small-8" style={{ paddingLeft: 20 }}>
            {benefit.length > 0
              ? benefit.map((singleBenefit, index) => (
                  <div style={{ paddingBottom: 10 }} key={index}>
                    {benefit.length > 1 && (
                      <div
                        style={{
                          fontWeight: 600,
                          padding: "10px 0px",
                          fontSize: 14,
                        }}
                      >
                        {singleBenefit.pbpBenefitName}
                      </div>
                    )}
                    {singleBenefit.pbpBenefitDesc &&
                      singleBenefit.pbpBenefitDesc
                        .replace(/\\*\\n/g, "\n")
                        .replace(/\\/g, "")
                        .split("\n")
                        .filter(Boolean)
                        .map((line, lineIndex) => (
                          <div key={lineIndex} style={{ fontSize: 14 }}>
                            {line}
                          </div>
                        ))}
                  </div>
                ))
              : "-"}
          </div>
        )}
      </div>
    </>
  );
};

export default SingleInfoBenefit;
